// Conversations Sam conservées d'une session à l'autre. Les garder est voulu
// — l'élève qui quitte et revient retrouve son fil — mais les maps par
// activité s'accumulaient sans purge, dans le même localStorage dont le quota
// a DÉJÀ été dépassé une fois (c'est la raison d'être du transform de
// persistance). Le jour où il saute, ce n'est pas Sam qui tombe : c'est toute
// la persistance de l'application.
export const SAM_KEPT_ACTIVITIES = 3

/**
 * Ne garde que les N dernières activités d'une map indexée par id d'activité.
 *
 * Les ids sont auto-incrémentés et JavaScript énumère les clés entières par
 * ordre CROISSANT, quel que soit l'ordre d'insertion : les dernières clés sont
 * donc bien les activités les plus récentes. Cette règle supprime des données
 * persistées — d'où le test qui l'épingle.
 */
export const pruneSamByActivityId = (map) => {
    if (!map) return map
    const keys = Object.keys(map)
    if (keys.length <= SAM_KEPT_ACTIVITIES) return map
    return keys.slice(-SAM_KEPT_ACTIVITIES).reduce((acc, key) => {
        acc[key] = map[key]
        return acc
    }, {})
}

/**
 * Retire des fils persistés les photos qui ne survivent pas au rechargement
 * ou pèsent trop lourd. Sur le web, la photo du brouillon est l'adresse d'un
 * objet (`blob:`, morte avec la page) ou une data URL en pleine résolution :
 * deux ou trois « Où j'en suis » pesaient plusieurs Mo dans la même clé que
 * tout le reste, ce qui suffit à dépasser le quota. La bulle d'une photo sans
 * image ne s'affiche pas, et le texte de son message, qui dit à Sam qu'une
 * photo est passée, reste.
 */
export const dropInlinePhotos = (conversations) => {
    if (!conversations) return conversations
    return Object.fromEntries(
        Object.entries(conversations).map(([activityId, conversation]) => [
            activityId,
            {
                ...conversation,
                messages: (conversation?.messages ?? []).map((message) => {
                    if (!/^(data|blob):/.test(message?.imageUri ?? "")) return message
                    const { imageUri, ...rest } = message
                    return rest
                }),
            },
        ])
    )
}
